// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__gvz3J","rotation":"Loader_rotation__2SnQn"};